module.exports = __webpack_public_path__ + "assets/flags/lt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lt.svg
// module id = 505
// module chunks = 0